import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AdditionalWorkDTO } from '../../models/additional-work.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequestService } from '../../services/base-request.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages, Service, TernaryDecision, AdditionalOrWorkCompeletion, Decision, ServiceStatus } from 'src/app/shared/models/enums.model';
import { AdditionalWorkService } from '../../services/additional-work.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserResponseDto, AdminResponseDto } from '../../models/adminResponseDto';
import { AdminDecisionService } from '../../services/admin-decision.service';
import { RepairRequestService } from '../../services/repair-request.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-additional-work',
  templateUrl: './additional-work.component.html',
  styleUrls: ['./additional-work.component.css']
})
export class AdditionalWorkComponent implements OnInit {
  additionalWorkForm: FormGroup;
  model: AdditionalWorkDTO;
  submitted = false;
  responseObject: ResponseObject;
  displayedLang: string;
  requestId: any;
  baseRequestDTO: BaseRequest;
  loading = false;
  baseRequestId: any;
  requestMode: string;
  isReadOnly: boolean;
  serviceType = Service;
  isAdditional: boolean;
  ternartDecision = TernaryDecision;
  additionalDecisions = AdditionalOrWorkCompeletion;
  additionalDecisionsKeys = Object.keys(this.additionalDecisions);
  responseObj: ResponseObject;
  testedDiv: number;
  numberRegex: string = '^[0-9]*$';
  decision = Decision;
  decisionKeys = Object.keys(this.decision);
  userDecision: number;
  showRequest = true;
  isErrorMessage :boolean = false;
  @Input() IsCompletionView: boolean;
  isRequestHistory :boolean = false;
  additonalWorkIsRejectedByUser: boolean = false;
  lockTaskErrorMessage :boolean = false;

  constructor(private formBuilder: FormBuilder, private alertService: AlertService,
    private baseRequestService: BaseRequestService,
    private translate: TranslateService,
    private globalSrv: GlobalServices,
    private additinalWorkService: AdditionalWorkService,
    private route: ActivatedRoute,
    private router: Router,
    private adminDecisionService: AdminDecisionService,
    private authSrevice: AuthenticationService
  ) {
    // this.isAdditional=true;
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);

    this.additionalDecisionsKeys = this.additionalDecisionsKeys.slice(this.additionalDecisionsKeys.length / 2);

    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId){
    this.baseRequestId = history.state.data.requestId;
    } else {
      window.history.back();
    }
    // this.baseRequestId = this.route.snapshot.params.Id;
  }

  ngOnInit() {
    this.buildForm();

    this.getBaseRequest();
    this.requestMode = this.route.snapshot.routeConfig.path;
    if (this.requestMode == "additionalWork") {
      this.isReadOnly = false;

    }
    else {
      this.isReadOnly = true;
      this.getAdditionalWork(this.baseRequestId);
    }
    if (history.state.data && history.state.data.isCompleted){
      this.isReadOnly = true;
      this.getAdditionalWork(this.baseRequestId);
      this.isRequestHistory = true;
     }

  }

  getAdditionalWork(baseRequestId) {
    this.additinalWorkService.getAdditionalWork(this.baseRequestId).subscribe(
      d => {
        this.model = d.Data;
        this.additionalWorkForm.patchValue({
          AdditionalWork: this.model.AdditionalWork,
          EstimatedCostOfAdditionalWork: this.model.EstimatedCostOfAdditionalWork
        });
      }
    )
  }

  getBaseRequest() {
    this.requestId = this.baseRequestId;
    this.baseRequestService.getBaseRequest(this.requestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        if(this.baseRequestDTO.StatusId ==ServiceStatus.AdditionalWorkRejected){
          this.additonalWorkIsRejectedByUser = true;
        }

      }

    );
    // if(this.baseRequestDTO.StatusId ==ServiceStatus.AdditionalWorkRejected){
    //   this.additonalWorkIsRejectedByUser = true;
    // }
  }
  buildForm() {
    this.additionalWorkForm = this.formBuilder.group({
      AdditionalWork: ['', [Validators.required]],
      EstimatedCostOfAdditionalWork: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
    });
  }
  get f() {

    return this.additionalWorkForm.controls;
  }

  addAdditionalWork() {
    this.isAdditional = true;
  }

  adminResponse(adminreponse: boolean) {
    var adminreponseDto = new AdminResponseDto();
    adminreponseDto.response = adminreponse;
    adminreponseDto.requestId = this.requestId;
    adminreponseDto.userEmail = this.authSrevice.currentUserValue.UserName;
    adminreponseDto.serviceId = this.baseRequestDTO.ServiceId;
    this.additinalWorkService.adminReviewRequest(adminreponseDto).subscribe(
      (data: ResponseObject) => {
        // + this.baseRequestId
        this.router.navigate(['/myTasks' ])

      });


  }

  userResponse(userResponse: number) {
    var responseResult = new UserResponseDto();
    responseResult.response = userResponse;
    responseResult.requestId = this.baseRequestId;
    responseResult.userName = this.authSrevice.currentUserValue.UserName;
    responseResult.serviceId = this.baseRequestDTO.ServiceId;
    this.additinalWorkService.setUserResponse(responseResult).subscribe(
      (data: ResponseObject) => {
        this.responseObject = data;
        if (this.responseObject.Success) {
          let message: string;
          this.additionalWorkForm.reset();
          this.showRequest = false;
          this.loading = false;
          // console.log("Success");
        }
        else {
          this.loading = false;
          this.showRequest = false;
          this.isErrorMessage=true;
          // console.log("Fail");
        }
      });
  }
  onSubmit(b) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.additionalWorkForm.invalid) {
      return;
    }
    //Enable Loader
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.model = this.additionalWorkForm.getRawValue();
    this.model.BaseRequestId = this.baseRequestId;
    this.model.AdminEmail = this.authSrevice.currentUserValue.UserName;
    this.model.serviceId = this.baseRequestDTO.Service.Id;
    this.additinalWorkService.addAdditionalWork(this.model)
      .subscribe(
        (data: ResponseObject) => {
          this.responseObject = data;
          if (this.responseObject.Success) {
            let message: string;
            this.additionalWorkForm.reset();
            this.showRequest = false;
            this.loading = false;
            //Disable Loader
            this.globalSrv.isLoaderEnabled = false;
          }else if(this.responseObject.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser")!=null){
            this.lockTaskErrorMessage = true;
            this.showRequest = false;
            //Disable Loader
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.loading = false;
            this.isErrorMessage = true;
            this.showRequest = false;
            //Disable Loader
            this.globalSrv.isLoaderEnabled = false;
          }

        });
  }

  changeDecision(value) {
    // this.buildForm(value);
    // this.adminDecisionForm.patchValue({
    //   Decision: value
    // });

    this.testedDiv = value;
  }
  changeUserDecision(value) {
    this.userDecision = value;
  }


}
